import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import FileUpload from '../../../components/ul/FileUpload.jsx';
import NotFound from '../../../components/ul/NotFound';
import Loader from '../../../components/Loader';
import AdsNavbar from '../AdsNavbar';
import TopNavbar from '../TopNavbar.jsx';
import {
    FaArrowLeft,
    FaArrowRight,
    FaEdit,
    FaTrash,
    FaEye,
    FaUpload,
    FaRegFileImage,
    FaRegFileVideo,
    FaPlay,
    FaPause,
    FaExpand,
    FaCompress,
    FaVolumeUp,
    FaVolumeMute,
    FaClock
} from 'react-icons/fa';
import { IoMdSearch, IoMdClose } from 'react-icons/io';
import { MdDeleteSweep } from 'react-icons/md';
import { LuDot } from 'react-icons/lu';
import { toast } from 'react-toastify';



// Import utilities
import {
    MAX_FILE_SIZE_IMAGE,
    videoSizeExceededMessage,
    videoType,
    invalidVideoMessage,
    MAX_FILE_SIZE_VIDEO
} from '../../../components/imageType';
import { formatView } from '../../../components/formatView';
import generateCaptcha from '../../../components/captcha';
import Calling from '../../../api/Calling';

const InHouseAds = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [formInfo, setFormInfo] = useState({
        mainTitle: '',
        subTitle: '',
        medType: 'image',
        description: '',
        callToAction: '',
        btnName: '',
        web_stay_time: 1,
        adType: 'fs_web'
    });
    const [inHouseAdsStatus, setInHouseAdsStatus] = useState(false);
    const [data, setData] = useState([]);
    const [selectRecord, setSetectRecord] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [file, setFile] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    const [iconFile, setIconFile] = useState(null);
    const [fileProcessing, setFileProcessing] = useState({
        icon: false,
        image: false,
        video: false
    });
    const [fileStatus, setFileStatus] = useState({
        icon: null,
        image: null,
        video: null
    });
    const [search, setSearch] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [previewMedia, setPreviewMedia] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const videoRef = useRef(null);
    const previewContainerRef = useRef(null);
    const imageTypeMain = [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'image/gif'
    ];

    const togglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
            setIsMuted(!isMuted);
        }
    };

    const toggleFullscreen = () => {
        if (!document.fullscreenElement && previewContainerRef.current) {
            if (previewContainerRef.current.requestFullscreen) {
                previewContainerRef.current.requestFullscreen();
            } else if (previewContainerRef.current.webkitRequestFullscreen) {
                previewContainerRef.current.webkitRequestFullscreen();
            } else if (previewContainerRef.current.msRequestFullscreen) {
                previewContainerRef.current.msRequestFullscreen();
            }
            setIsFullscreen(true);
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            setIsFullscreen(false);
        }
    };

    const openPreviewModal = (item) => {
        setPreviewMedia(item);
        setIsPlaying(false);
        setIsMuted(false);
        // Reset video when opening new item
        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.currentTime = 0;
            }
        }, 100);
    };

    const closePreviewModal = () => {
        if (videoRef.current) {
            videoRef.current.pause();
        }
        setPreviewMedia(null);
        setIsPlaying(false);
    };

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getInHouseAds(page, 100, search);
            console.log(resp)
            if (resp?.status) {
                setData(resp?.data);
                setTotalPages(resp?.totalPages || 1);
                setInHouseAdsStatus(resp?.InHouseAdsStatus);
            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            return toast.error('Select valid image, video and icon files');
        }
        if (formInfo.web_stay_time < 1) {
            return toast.error('Web stay time must be at least 1 second');
        }
        setLoader(true);
        try {
            const formData = new FormData();
            // formData.append('mainTitle', formInfo.mainTitle);
            // formData.append('subTitle', formInfo.subTitle);
            // formData.append('medType', formInfo.medType);
            // formData.append('description', formInfo.description);
            // formData.append('callToAction', formInfo.callToAction);
            // formData.append('btnName', formInfo.btnName);
            // formData.append('web_stay_time', formInfo.web_stay_time);
            // formData.append('icon', iconFile); 
            // formData.append('adType', formInfo.adType);


            formData.append('mainTitle', "Ad-" + (data?.length + 1) || 1);
            formData.append('subTitle', "Ad-" + (data?.length + 1) || 1);
            formData.append('medType', formInfo.medType);
            formData.append('description', "Ad-" + (data?.length + 1) || 1);
            formData.append('callToAction', formInfo.callToAction);
            formData.append('btnName', "Install");
            formData.append('web_stay_time', formInfo.web_stay_time);
            formData.append('adType', formInfo.adType);
            formData.append('icon', imageFile);
            if (formInfo?.medType === 'image') {
                formData.append('image', imageFile);
            } else {
                formData.append('video', videoFile);
            }
            const resp = await Calling.uploadInHouseAds(formData);
            if (resp?.status) {
                toast.success(resp?.message || 'Upload successful!');
            } else {
                toast.error(resp?.message || 'Upload failed!');
            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setFormInfo({
                mainTitle: '',
                subTitle: '',
                medType: 'image',
                description: '',
                callToAction: '',
                btnName: '',
                web_stay_time: 1,
                adType: 'fs_web'
            });
            setFile(false);
            setFileProcessing({
                image: false,
                video: false,
                icon: false
            });
            setFileStatus({
                image: null,
                video: null,
                icon: null
            });
            setLoader(false);
            setShowForm(false);
            setImageFile(null);
            setVideoFile(null);
            setIconFile(null);
            fetchData();
        }
    };

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        // For number inputs, convert the value to a number
        const processedValue = type === 'number' ? Number(value) : value;
        setFormInfo({ ...formInfo, [name]: processedValue });
    };

    const handleChangeFile = (e) => {
        const { name, files, id } = e.target;
        const file = files[0];

        if (file) {
            const isImage = name === 'image';
            const isIcon = name === 'icon';
            const isVideo = name === 'video';

            // Determine the file type and max size
            let isValidType = false;
            let maxSize = 0;
            let errorMessage = '';

            if (isImage || isIcon) {
                isValidType = imageTypeMain.includes(file.type);
                maxSize = MAX_FILE_SIZE_IMAGE;
                errorMessage = "Please select a valid image file. Allowed types: 'image/png', 'image/jpg', 'image/jpeg', 'image/gif'";
            } else if (isVideo) {
                isValidType = videoType.includes(file.type);
                maxSize = MAX_FILE_SIZE_VIDEO;
                errorMessage = videoSizeExceededMessage;
            }

            // Validate file type
            if (!isValidType) {
                // Use the specific error message for image types
                const fileTypeError = isImage || isIcon
                    ? "Please select a valid image file. Allowed types: 'image/png', 'image/jpg', 'image/jpeg', 'image/gif'"
                    : invalidVideoMessage;

                if (isImage) setImageFile(null);
                if (isIcon) setIconFile(null);
                if (isVideo) setVideoFile(null);
                setFileProcessing((prevState) => ({ ...prevState, [id]: false }));
                setFileStatus((prevState) => ({ ...prevState, [id]: 'error' }));
                toast.error(fileTypeError);
                setFile(false);
                e.target.value = '';
                return;
            }

            // Validate file size
            if (file.size > maxSize) {
                // Use the specific error message based on file type
                const sizeErrorMessage = isImage || isIcon
                    ? `Image size should not exceed ${Math.round(MAX_FILE_SIZE_IMAGE / 1024 / 1024)}MB`
                    : videoSizeExceededMessage;

                toast.error(sizeErrorMessage);
                if (isImage) setImageFile(null);
                if (isIcon) setIconFile(null);
                if (isVideo) setVideoFile(null);
                setFileProcessing((prevState) => ({ ...prevState, [id]: false }));
                setFileStatus((prevState) => ({ ...prevState, [id]: 'error' }));
                setFile(false);
                e.target.value = '';
                return;
            }

            // Start processing the file
            setFileProcessing((prevState) => ({ ...prevState, [id]: true }));
            setFileStatus((prevState) => ({ ...prevState, [id]: null }));

            // Simulate file processing
            setTimeout(() => {
                setFileProcessing((prevState) => ({ ...prevState, [id]: false }));
                setFileStatus((prevState) => ({ ...prevState, [id]: 'success' }));
            }, 1000);

            // Update the state with the appropriate file type
            if (isImage) {
                setImageFile(file);
                setFile(true);
            } else if (isIcon) {
                setIconFile(file);
                setFile(true);
            } else if (isVideo) {
                setVideoFile(file);
                setFile(true);
            }
        }
    };

    const handleSelect = (recordId) => {
        setSetectRecord((prev) =>
            selectRecord.includes(recordId)
                ? prev.filter(id => id !== recordId)
                : [...prev, recordId]
        );
    };

    const handleDeleteAds = async (id) => {
        const content = `You are about to delete the In House ads. To confirm, please solve this math problem.`;
        const check = generateCaptcha(content);
        if (check) {
            try {
                setLoader(true);
                let body = {};
                if (id) {
                    body = { id: [id] };
                } else {
                    body = { id: selectRecord };
                }
                const response = await Calling.deleteInhouseAds(body);
                if (response?.status) {
                    toast.success(response?.message || "In House ads deleted successfully.");
                    setSetectRecord([]);
                } else {
                    toast.error(response?.message || "Failed to delete In House ads");
                }
            } catch (error) {
                console.error("Error deleting ads:", error);
            } finally {
                setLoader(false);
                fetchData();
            }
        } else {
            toast.error("Incorrect answer to the captcha.", { autoClose: 2000 });
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleInHouseAdsStatus = async (id, status) => {
        try {
            setLoader(true);
            const resp = await Calling.setInHouseAdsStatus(id, status);
            if (resp?.status) {
                toast.success(resp?.message || 'Status updated successfully!');
            } else {
                toast.error(resp?.message || 'Failed to update status!');
            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
            fetchData();
        }
    };

    const handleEditInHouseAds = (id) => {
        navigate(`/manage/ads/inHouseAds/edit/${id}`);
    };

    const handleViewAnalytics = (id) => {
        navigate(`/views/dashboard/${id}`);
    };

    const handleReset = () => {
        setImageFile(null);
        setVideoFile(null);
        setIconFile(null);
        setFormInfo({
            mainTitle: '',
            subTitle: '',
            medType: 'image',
            description: '',
            callToAction: '',
            btnName: '',
            adType: 'fs_web'
        });
        setFile(false);
        setFileProcessing({
            icon: false,
            image: false,
            video: false
        });
        setFileStatus({
            icon: null,
            image: null,
            video: null
        });

    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    useEffect(() => {
        if (search.trim() !== '') {
            const delayDebounce = setTimeout(() => {
                fetchData();
            }, 500);

            return () => clearTimeout(delayDebounce);
        } else {
            fetchData();
        }
    }, [search, page]);

    return (
        <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
            <div className="w-full mt-4 mb-2">
                <h1 className="text-xl sm:text-2xl font-bold">Ad Management</h1>
            </div>

            <div className='bg-main-white rounded-xl shadow-md overflow-hidden'>
                <TopNavbar selectState={'android'} />
                <hr className='mt-2 bg-main-border border-[1px]' />
                <AdsNavbar selectState={'inhouseads'} />
                <hr className='mt-2 bg-main-border border-[1px]' />

                {/* Header with toggle button */}
                <div className='p-6'>
                    <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4'>
                        <div className="flex items-center space-x-4">
                            <h1 className='text-xl md:text-2xl font-bold text-main-font'>In House Ads</h1>
                            {inHouseAdsStatus ? (
                                <span className='px-4 py-1 text-sm rounded-full bg-green-100 text-green-600 flex items-center'>
                                    <LuDot size={20} className="animate-pulse" /> Running
                                </span>
                            ) : (
                                <span className='px-4 py-1 text-sm rounded-full bg-red-100 text-red-600 flex items-center'>
                                    <LuDot size={20} /> Not Running
                                </span>
                            )}
                        </div>
                        <button
                            onClick={() => setShowForm(!showForm)}
                            className="bg-main-blue hover:bg-main-blue/80 text-white px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2"
                        >
                            {showForm ? 'Hide Form' : <><FaUpload /> Create New Ad</>}
                        </button>
                    </div>

                    <hr className='border-main-border mb-6' />

                    {/* Form with animation */}
                    <div className={`transition-all duration-500 ease-in-out overflow-hidden ${showForm ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                        <div className="bg-gray-50 p-6 rounded-lg shadow-inner mb-8">
                            <h2 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                                <FaRegFileImage className="mr-2" />
                                Create New In-House Advertisement
                            </h2>

                            <form onSubmit={handleSubmit} encType="multipart/form-data" className="space-y-2">
                                {/* Top Section with Type, Title, Subtitle */}
                                <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
                                    <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2 flex items-center' htmlFor='medType'>
                                            {formInfo.medType === 'image' ? (
                                                <FaRegFileImage className="mr-2 text-blue-500" />
                                            ) : (
                                                <FaRegFileVideo className="mr-2 text-red-500" />
                                            )}
                                            Type
                                        </label>
                                        <select
                                            id='medType'
                                            name='medType'
                                            value={formInfo.medType}
                                            onChange={handleChange}
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                        >
                                            <option value="image">Image</option>
                                            {/* <option value="video">Video</option> */}
                                        </select>
                                    </div>
                                    <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2 flex items-center' htmlFor='adType'>
                                            <FaRegFileImage className="mr-2 text-blue-500" />
                                            Ad Type
                                        </label>
                                        <select
                                            id='adType'
                                            name='adType'
                                            value={formInfo.adType}
                                            onChange={handleChange}
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                        >
                                            {/* <option value="fs">Full Screen</option> */}
                                            {/* <option value="ntv">Natvie</option> */}
                                            <option value="fs_web">FS Web</option>
                                            {/* <option value="rwd_web">RWD Web</option> */}
                                        </select>
                                    </div>
                                    <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2' htmlFor='callToAction'>
                                            Call to Action URL
                                        </label>
                                        <input
                                            type='text'
                                            id='callToAction'
                                            name='callToAction'
                                            value={formInfo.callToAction}
                                            onChange={handleChange}
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                            placeholder='https://example.com/action'
                                            required
                                        />
                                    </div>
                                    <div className='flex flex-col'>

                                        <label className='text-gray-700 font-medium mb-2 flex items-center' htmlFor='web_stay_time'>
                                            <FaClock className="mr-2 text-orange-500" />
                                            Web Stay Time (seconds)
                                        </label>
                                        <input
                                            type='number'
                                            id='web_stay_time'
                                            name='web_stay_time'
                                            value={formInfo.web_stay_time}
                                            onChange={handleChange}
                                            min="1"
                                            step="1"
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                            placeholder='Minimum time in seconds'
                                            required
                                        />
                                        <p className="text-xs text-gray-500 mt-1">Minimum time (in seconds) users must stay on the page</p>
                                    </div>
                                    {/* <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2' htmlFor='mainTitle'>
                                            Title
                                        </label>
                                        <input
                                            type='text'
                                            id='mainTitle'
                                            name='mainTitle'
                                            value={formInfo.mainTitle}
                                            onChange={handleChange}
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                            placeholder='Enter Main Title'
                                            required
                                        />
                                    </div> */}
                                    {/* <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2' htmlFor='subTitle'>
                                            Subtitle
                                        </label>
                                        <input
                                            type='text'
                                            id='subTitle'
                                            name='subTitle'
                                            value={formInfo.subTitle}
                                            onChange={handleChange}
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                            placeholder='Enter Subtitle'
                                            required
                                        />
                                    </div> */}
                                </div>

                                {/* Description */}
                                {/* <div className='flex flex-col'>
                                    <label className='text-gray-700 font-medium mb-2' htmlFor='description'>
                                        Details
                                    </label>
                                    <textarea
                                        id='description'
                                        name='description'
                                        value={formInfo.description}
                                        onChange={handleChange}
                                        className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                        placeholder='Enter Description'
                                        rows="4"
                                        required
                                    />
                                </div> */}

                                {/* CTA and Button Name */}
                                {/* <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                                    <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2' htmlFor='btnName'>
                                            Button Text
                                        </label>
                                        <input
                                            type='text'
                                            id='btnName'
                                            name='btnName'
                                            value={formInfo.btnName}
                                            onChange={handleChange}
                                            className='w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-200'
                                            placeholder='Learn More'
                                            required
                                        />
                                    </div>
                                </div> */}



                                {/* File Uploads */}
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                                    {/* <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2' htmlFor='icon'>
                                            Icon (Brand Logo)
                                        </label>
                                        <div className='relative bg-gray-100 rounded-lg p-4 border-2 border-dashed border-gray-300 hover:border-main-blue transition-all duration-200'>
                                            <FileUpload
                                                id="icon"
                                                name='icon'
                                                accept='image/png,image/jpg,image/jpeg,image/gif'
                                                onChange={handleChangeFile}
                                                required={true}
                                                className="relative z-10"
                                            />
                                            {fileProcessing['icon'] ? (
                                                <div className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded-lg'>
                                                    <div className='w-8 h-8 border-4 border-t-main-blue border-blue-200 rounded-full animate-spin'></div>
                                                </div>
                                            ) : fileStatus['icon'] === 'error' ? (
                                                <div className='absolute top-4 right-4 text-red-500'>✘</div>
                                            ) : fileStatus['icon'] === 'success' ? (
                                                <div className='absolute top-4 right-4 text-green-500'>✓</div>
                                            ) : null}
                                        </div>
                                    </div> */}

                                    <div className='flex flex-col'>
                                        <label className='text-gray-700 font-medium mb-2' htmlFor={formInfo.medType}>
                                            {formInfo.medType === 'image' ? 'Advertisement Image' : 'Advertisement Video'}
                                        </label>
                                        <div className='relative bg-gray-100 rounded-lg p-4 border-2 border-dashed border-gray-300 hover:main-blue transition-all duration-200'>
                                            <FileUpload
                                                id={formInfo.medType}
                                                name={formInfo.medType}
                                                accept={formInfo.medType === 'image' ? 'image/png,image/jpg,image/jpeg,image/gif' : 'video/mp4'}
                                                onChange={handleChangeFile}
                                                required={true}
                                                className="relative z-10"
                                            />
                                            {fileProcessing[formInfo.medType] ? (
                                                <div className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded-lg'>
                                                    <div className='w-8 h-8 border-4 border-t-main-blue border-blue-200 rounded-full animate-spin'></div>
                                                </div>
                                            ) : fileStatus[formInfo.medType] === 'error' ? (
                                                <div className='absolute top-4 right-4 text-red-500'>✘</div>
                                            ) : fileStatus[formInfo.medType] === 'success' ? (
                                                <div className='absolute top-4 right-4 text-green-500'>✓</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>


                                {/* Action Buttons */}
                                <div className='flex flex-col sm:flex-row gap-4 pt-4'>
                                    <button
                                        type="submit"
                                        className="bg-main-blue hover:bg-main-blue/80 cursor-pointer text-white px-6 py-3 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 font-medium"
                                        disabled={!file || loader}
                                    >
                                        {loader ? (
                                            <div className='w-5 h-5 border-2 border-t-white border-white/20 rounded-full animate-spin mr-2'></div>
                                        ) : (
                                            <FaUpload className="mr-2" />
                                        )}
                                        {loader ? 'Uploading...' : 'Upload Ad'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleReset}
                                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-3 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 font-medium"
                                    >
                                        Reset Form
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <hr className='border-t-2 border-gray-100' />

                {/* Ads Listing Section */}
                <div className='bg-main-white'>
                    <div className='p-6'>
                        <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6'>
                            <h2 className='text-xl font-bold text-gray-800 mb-3 sm:mb-0'>
                                Your Advertisements
                                <span className="ml-2 text-sm font-normal text-gray-500">
                                    ({data.length} total)
                                </span>
                            </h2>
                            <div className="relative flex items-center gap-2 w-full sm:w-64">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <IoMdSearch className="text-gray-400" size={18} />
                                </div>
                                <input
                                    type="search"
                                    className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-main-blue focus:outline-none"
                                    value={search}
                                    onChange={handleSearchChange}
                                    placeholder="Search ads..."
                                />
                            </div>
                        </div>

                        {/* Table section with animation */}
                        <div className="bg-white rounded-lg shadow overflow-hidden transition-all duration-300">
                            <div className="overflow-x-auto">
                                <table className='w-full min-w-[1000px]'>
                                    <thead className='bg-main-th text-gray-700 uppercase'>
                                        <tr>
                                            <th className='px-6 py-4 text-left text-xs font-medium rounded-tl-lg'>
                                                <div className="flex items-center">
                                                    <input
                                                        type='checkbox'
                                                        className='w-4 h-4 text-main-blue border-gray-300 rounded focus:ring-main-blue/80'
                                                        onChange={(e) => setSetectRecord(e.target.checked ? data.map(v => v._id) : [])}
                                                    />
                                                    {selectRecord.length > 0 && (
                                                        <button
                                                            className="ml-3 bg-red-50 hover:bg-red-100 text-red-600 p-1 rounded transition-colors duration-200"
                                                            onClick={() => handleDeleteAds(null)}
                                                        >
                                                            <MdDeleteSweep size={20} />
                                                        </button>
                                                    )}
                                                </div>
                                            </th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">#</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Title / Subtitle</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Media</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Ad</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Type</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Status</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Performance</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Stay Time</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Date</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium">Actions</th>
                                        </tr>
                                    </thead>
                                    {loader ? (
                                        <tbody>
                                            <tr>
                                                <td colSpan={9} className="text-center py-8">
                                                    <Loader loader={loader} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            {data.length > 0 ? (
                                                data?.map((item, index) => (
                                                    <tr key={item._id} className="hover:bg-main-thHover transition-colors duration-150">
                                                        <td className="px-6 py-4 text-left">
                                                            <input
                                                                type='checkbox'
                                                                checked={selectRecord?.includes(item?._id)}
                                                                onChange={() => handleSelect(item?._id)}
                                                                className='w-4 h-4 text-main-blue border-gray-300 rounded focus:ring-main-blue/20'
                                                            />
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            {(page - 1) * 100 + index + 1}
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className="flex items-center">
                                                                <div className="h-10 w-10 flex-shrink-0">
                                                                    <img
                                                                        src={item?.icon}
                                                                        alt="Icon"
                                                                        className="h-10 w-10 rounded-full object-cover"
                                                                    />
                                                                </div>
                                                                <div className="ml-4">
                                                                    <div className="text-sm font-medium text-gray-900">
                                                                        {item?.mainTitle}
                                                                    </div>
                                                                    <div className="text-sm text-gray-500">
                                                                        {item?.subTitle}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            {item.medType === "image" ? (
                                                                <div
                                                                    className="h-16 w-24 rounded-md overflow-hidden cursor-pointer relative group"
                                                                    onClick={() => openPreviewModal(item)}
                                                                >
                                                                    <img
                                                                        src={item?.medView}
                                                                        alt="Media"
                                                                        className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
                                                                    />
                                                                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300">
                                                                        <FaEye className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" size={20} />
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className="h-16 w-24 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center cursor-pointer relative group"
                                                                    onClick={() => openPreviewModal(item)}
                                                                >
                                                                    <video className="h-full w-full object-cover">
                                                                        <source src={item?.medView} type="video/mp4" />
                                                                    </video>
                                                                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 group-hover:bg-opacity-50 transition-all duration-300">
                                                                        <FaPlay className="text-white" size={20} />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item?.medType === 'image'
                                                                ? 'bg-blue-100 text-blue-800'
                                                                : 'bg-purple-100 text-purple-800'
                                                                }`}>
                                                                {item?.adType}
                                                            </span>
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item?.medType === 'image'
                                                                ? 'bg-blue-100 text-blue-800'
                                                                : 'bg-purple-100 text-purple-800'
                                                                }`}>
                                                                {item?.medType}
                                                            </span>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className="flex items-center">
                                                                <label className="relative inline-flex items-center cursor-pointer">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item?.status}
                                                                        onChange={() => handleInHouseAdsStatus(item?._id, !item?.status)}
                                                                        className="sr-only peer"
                                                                    />
                                                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-main-blue"></div>
                                                                </label>
                                                                <span className={`ml-2 text-xs ${item?.status ? 'text-green-600' : 'text-red-600'}`}>
                                                                    {item?.status ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className="flex flex-col">
                                                                <div className="flex items-center mb-1">
                                                                    <FaEye className="text-main-blue mr-2" size={14} />
                                                                    <span
                                                                        className="text-sm text-main-blue font-medium cursor-pointer hover:underline"
                                                                        onClick={() => handleViewAnalytics(item?._id)}
                                                                    >
                                                                        {formatView(item?.view)}
                                                                    </span>
                                                                </div>
                                                                <div className="flex items-center">
                                                                    <svg className="text-green-500 mr-2" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M20 16L14 10L10 14L4 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M20 16H15V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                    <span
                                                                        className="text-sm text-green-600 font-medium cursor-pointer hover:underline"
                                                                        onClick={() => handleViewAnalytics(item?._id)}
                                                                    >
                                                                        {formatView(item?.clickCount)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            <span className="ml-2 text-orange-600">{item?.web_stay_time || 1}s</span>
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            {new Date(item.createdAt).toLocaleDateString('en-US', {
                                                                day: 'numeric',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}
                                                        </td>
                                                        <td className="px-6 py-4 text-sm font-medium">
                                                            <div className="flex space-x-2">
                                                                <button
                                                                    onClick={() => handleEditInHouseAds(item?._id)}
                                                                    className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 p-2 rounded-full transition-colors duration-200"
                                                                >
                                                                    <FaEdit size={16} />
                                                                </button>
                                                                <button
                                                                    onClick={() => handleDeleteAds(item?._id)}
                                                                    className="text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 p-2 rounded-full transition-colors duration-200"
                                                                >
                                                                    <FaTrash size={16} />
                                                                </button>
                                                                <a
                                                                    href={item.callToAction}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 p-2 rounded-full transition-colors duration-200"
                                                                >
                                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M15 3H21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={9}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    )}
                                </table>
                            </div>

                            {/* Pagination Controls */}
                            {data.length > 0 && (
                                <div className="bg-gray-50 px-6 py-4 flex items-center justify-between border-t border-gray-200 rounded-b-lg">
                                    <div className="flex gap-2">
                                        <button
                                            className={`px-4 py-2 rounded-md flex items-center gap-1 transition-colors duration-200 ${page === 1
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-main-blue text-white hover:bg-main-blue/80"
                                                }`}
                                            onClick={() => handlePageChange(page - 1)}
                                            disabled={page === 1}
                                        >
                                            <FaArrowLeft size={14} /> Previous
                                        </button>
                                        <button
                                            className={`px-4 py-2 rounded-md flex items-center gap-1 transition-colors duration-200 ${page === totalPages
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-main-blue text-white hover:bg-main-blue/80"
                                                }`}
                                            onClick={() => handlePageChange(page + 1)}
                                            disabled={page === totalPages}
                                        >
                                            Next <FaArrowRight size={14} />
                                        </button>
                                    </div>

                                    <div className="flex items-center text-sm text-gray-700">
                                        <span>Page</span>
                                        <span className="font-medium mx-2 bg-white border border-gray-300 rounded-md px-3 py-1">
                                            {page < 10 ? `0${page}` : page}
                                        </span>
                                        <span>of {totalPages < 10 ? `0${totalPages}` : totalPages}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Media Preview Modal */}
            {previewMedia && (
                <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
                    <div
                        ref={previewContainerRef}
                        className={`bg-white rounded-lg overflow-hidden max-w-4xl w-full mx-auto ${isFullscreen ? 'h-full' : 'max-h-[90vh]'}`}
                    >
                        {/* Modal Header */}
                        <div className="flex items-center justify-between bg-gray-100 px-6 py-3">
                            <div className="flex items-center">
                                <img
                                    src={previewMedia?.icon}
                                    alt="Icon"
                                    className="h-8 w-8 rounded-full object-cover mr-3"
                                />
                                <div>
                                    <h3 className="font-medium text-gray-800">{previewMedia?.mainTitle}</h3>
                                    <p className="text-sm text-gray-500">{previewMedia?.subTitle}</p>
                                </div>
                            </div>
                            <button
                                onClick={closePreviewModal}
                                className="text-gray-500 hover:text-gray-700 p-2 rounded-full hover:bg-gray-200 transition-colors duration-200"
                            >
                                <IoMdClose size={24} />
                            </button>
                        </div>

                        {/* Media Content */}
                        <div className="relative bg-black flex items-center justify-center">
                            {previewMedia.medType === "image" ? (
                                <img
                                    src={previewMedia?.medView}
                                    alt={previewMedia?.mainTitle}
                                    className="max-w-full max-h-[70vh] object-contain"
                                />
                            ) : (
                                <video
                                    ref={videoRef}
                                    className="max-w-full max-h-[50vh]"
                                    onPlay={() => setIsPlaying(true)}
                                    onPause={() => setIsPlaying(false)}
                                    onEnded={() => setIsPlaying(false)}
                                    onClick={togglePlay}
                                >
                                    <source src={previewMedia?.medView} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            )}

                            {/* Video Controls */}
                            {previewMedia.medType === "video" && (
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 flex items-center">
                                    <button
                                        onClick={togglePlay}
                                        className="text-white p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
                                    >
                                        {isPlaying ? <FaPause size={20} /> : <FaPlay size={20} />}
                                    </button>

                                    <button
                                        onClick={toggleMute}
                                        className="text-white p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-colors duration-200 ml-2"
                                    >
                                        {isMuted ? <FaVolumeMute size={20} /> : <FaVolumeUp size={20} />}
                                    </button>

                                    <div className="flex-grow"></div>

                                    <button
                                        onClick={toggleFullscreen}
                                        className="text-white p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-colors duration-200"
                                    >
                                        {isFullscreen ? <FaCompress size={20} /> : <FaExpand size={20} />}
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Ad Details */}
                        <div className="p-6">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">{previewMedia?.mainTitle}</h3>
                            <p className="text-gray-600 mb-4">{previewMedia?.description}</p>

                            <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                                <div>
                                    <span className="font-medium">Media Type:</span>
                                    <span className={`ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${previewMedia?.medType === 'image'
                                        ? 'bg-blue-100 text-blue-800'
                                        : 'bg-purple-100 text-purple-800'
                                        }`}>
                                        {previewMedia?.medType}
                                    </span>
                                </div>
                                <div>
                                    <span className="font-medium">Status:</span>
                                    <span className={`ml-2 ${previewMedia?.status ? 'text-green-600' : 'text-red-600'}`}>
                                        {previewMedia?.status ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                                <div>
                                    <span className="font-medium">Views:</span>
                                    <span className="ml-2 text-blue-600">{formatView(previewMedia?.view)}</span>
                                </div>
                                <div>
                                    <span className="font-medium">Clicks:</span>
                                    <span className="ml-2 text-green-600">{formatView(previewMedia?.clickCount)}</span>
                                </div>
                                <div>
                                    <span className="font-medium">Stay Time:</span>
                                    <span className="ml-2 text-orange-600">{previewMedia?.web_stay_time || 1}s</span>
                                </div>
                                <div>
                                    <span className="font-medium">Created:</span>
                                    <span className="ml-2">
                                        {new Date(previewMedia.createdAt).toLocaleDateString('en-US', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                        })}
                                    </span>
                                </div>
                            </div>

                            <div className="mt-6 flex gap-3">
                                <a
                                    href={previewMedia.callToAction}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-main-blue hover:bg-main-blue/80 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center"
                                >
                                    {previewMedia?.btnName || "Visit Site"}
                                    <svg className="ml-2" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15 3H21V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </a>

                                <button
                                    onClick={() => {
                                        closePreviewModal();
                                        handleEditInHouseAds(previewMedia?._id);
                                    }}
                                    className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg transition-colors duration-200 flex items-center"
                                >
                                    <FaEdit className="mr-2" size={16} />
                                    Edit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InHouseAds;